/// <amd-module name="MarkdownEditor/MarkdownComponent" />
export { MarkdownComponent } from "MarkdownEditor/Components/MarkdownComponent";
